export function pluralize(count, unitSingular, unitPlural?) {
  if (unitPlural) {
    return `${count} ${count === 1 ? unitSingular : unitPlural}`;
  } else {
    return `${count} ${count === 1 ? unitSingular : unitSingular + 's'}`;
  }
}
